<template>
  <div>
    <table-component
      ref="table"
      :table-div-id="tableDivId"
      :show-filter="false"
      :data="fetchData"
      table-class="table"
    >
      <!-- <table-column
        v-if="userType == 'funder'"
        :label="$t('reports.financing_request_date')"
        sort-as="prepayment_date"
      >
        <template slot-scope="row">
          <p>{{ row.formattedPrePaymentDate }}</p>
        </template>
      </table-column> -->
      <!-- v-else -->
      <table-column
        :label="
          $t(
            userType == 'funder' || userType == 'supplier'
              ? 'reports.pos.po_date'
              : 'invoices.date'
          )
        "
        sort-as="invoice_date"
        show="formattedPurchaseOrderDate"
      />
      <!-- <table-column
        v-if="userType == 'funder'"
        :label="$t('invoices.promised_payment_date')"
        sort-as="promised_date"
      >
        <template slot-scope="row">
          <p>
            {{ row.formattedPurchaseOrderDate }}
          </p>
        </template>
      </table-column> -->
      <!-- v-else -->
      <table-column
        :label="$t('invoices.due_date')"
        sort-as="due_date"
        show="formattedExpiryDate"
      />
      <!-- v-if="
          userType === 'super_admin' ||
            userType === 'supplier' ||
            userType === 'funder'
        " -->
      <table-column :label="$t('invoices.customer')" width="20%">
        <template slot-scope="row">
          <p v-if="row.buyer_stakeholder">
            <span
              v-if="
                userType == 'supplier' &&
                  // row.customer.parent_account_id &&
                  row.buyer_stakeholder.details.company &&
                  row.buyer_stakeholder.details.company.name
              "
            >
              {{ row.buyer_stakeholder.details.company.name }}
            </span>
            <span v-else-if="userType == 'supplier'">
              {{ row.buyer_stakeholder.details.user.name }}
            </span>
            <!-- {{row.buyer_stakeholder.details.user.name}} -->
            <span v-else>
              {{ row.buyer_stakeholder.details.company.name }}
            </span>
          </p>
        </template>
      </table-column>

      <!-- v-if="
          userType === 'super_admin' ||
            userType === 'anchor' ||
            userType === 'funder'
        " -->
      <table-column :label="$t('invoices.supplier')">
        <template slot-scope="row">
          <p v-if="row.supplier_stakeholder">
            <span
              v-if="
                row.supplier_stakeholder.details.company &&
                  row.supplier_stakeholder.details.company.name
              "
            >
              {{ row.supplier_stakeholder.details.company.name }}
            </span>
            <!-- {{row.supplier_stakeholder.details.user.name}} -->
          </p>
        </template>
      </table-column>
      <!-- v-if="userType != 'super_admin'" -->
      <table-column :label="$t('invoices.status')" sort-as="status">
        <template v-if="row.status" slot-scope="row">
          <span> {{ $t("invoices.status") }}</span>
          <!-- v-if="userType == 'anchor' && row.overall_status == 'SENT'" -->
          <span :class="'inv-status-' + row.status.toLowerCase()">{{
            row.status.toUpperCase()
          }}</span>
          <!-- <span
            v-if="userType == 'anchor' && row.overall_status == 'SENT'"
            :class="'inv-status-' + row.overall_status.toLowerCase()"
            >{{ $t("general.received").toUpperCase() }}</span
          > -->
          <!-- <span
            v-else-if="userType == 'anchor' && row.overall_status != 'SENT'"
            :class="'inv-status-' + row.overall_status.toLowerCase()"
            >{{
              row.overall_status != "PARTIALLY_PAID"
                ? row.overall_status
                : row.overall_status.replace("_", " ")
            }}</span
          >
          <span
            v-else-if="userType != 'anchor'"
            :class="'inv-status-' + row.overall_status.toLowerCase()"
            >{{
              row.overall_status != "PARTIALLY_PAID"
                ? row.overall_status
                : row.overall_status.replace("_", " ")
            }}</span
          > -->
        </template>
      </table-column>
      <!-- <table-column
          :label="$t('invoices.invoice_number')"
          show="invoice_number"
        /> -->
      <table-column :label="$t('pos.ref_num')" show="reference_number" />
      <table-column :label="$t('invoices.amount')" sort-as="total">
        <template slot-scope="row">
          <span>{{ $t("invoices.amount") }}</span>
          <div
            v-html="$utils.formatMoney(row.total, row.user.account.currency)"
          />
          <!-- <span>{{ row.total }}</span> -->
        </template>
      </table-column>
    </table-component>
  </div>
</template>
<script>
export default {
  props: {
    fetchData: { default: () => [], type: [Array, Function, Object] },
    tableDivId: { default: "", type: String }
  },
  data() {
    return {
      userType: ""
    };
  },
  created() {
    console.log("Data received in fetchData:", this.fetchData);

    if (
      localStorage.getItem("account_type") == "funder" ||
      localStorage.getItem("role") == "super_admin" ||
      localStorage.getItem("account_type") == "anchor"
    ) {
      this.advanceOption = false;
    } else {
      this.advanceOption = true;
    }
    if (localStorage.getItem("role") == "super_admin") {
      this.userType = "super_admin";
    } else if (localStorage.getItem("account_type") == "anchor") {
      this.userType = "anchor";
    } else if (localStorage.getItem("account_type") == "supplier") {
      this.userType = "supplier";
    } else if (localStorage.getItem("account_type") == "funder") {
      this.userType = "funder";
    }
  },
  methods: {}
};
</script>
<style scoped>
.table-component {
  min-height: 0px !important;
}
</style>
